/**
 * Entity Types list (/events/entity-types) — nouns the event catalog is built from.
 */
import { Boxes } from 'lucide-react'
import { MasterTypeList, type MasterTypeConfig } from './MasterTypeList'

const entityConfig: MasterTypeConfig = {
  title: 'Entity Types',
  singular: 'entity type',
  icon: Boxes,
  listEndpoint: 'getEventEntityTypes',
  upsertEndpoint: 'upsertEventEntityType',
  archiveEndpoint: 'archiveEventEntityType',
  dataKey: 'entityTypes',
  numberKey: 'entityTypeNumber',
  nameKey: 'entityTypeName',
  descKey: 'entityTypeDescription',
  nameRegex: /^[A-Z][a-zA-Z0-9]*$/,
  nameHint: 'PascalCase noun, e.g. Farm, Device',
  nameErrorHint: 'Use PascalCase — start with a capital letter, letters and numbers only, no spaces (e.g. FieldBoundary)',
  namePlaceholder: 'FieldBoundary',
}

export function EntityTypeList() {
  return <MasterTypeList config={entityConfig} />
}
